// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AddressConstants$PorterinFeature from "../../../core/constants/AddressConstants.mjs";

var default_input = {
  pickup_address: AddressConstants$PorterinFeature.default_address,
  drop_address: AddressConstants$PorterinFeature.default_address,
  name: "",
  mobile: "",
  requirement: undefined,
  consent_for_callback: true
};

var Form;

export {
  Form ,
  default_input ,
}
/* No side effect */
